






























































































































import { ref, defineComponent, useContext } from '@nuxtjs/composition-api'
import { sectionCoreProps } from '@/mixins/sectionCore'
import Loader from '@/plugins/loader/Load.vue'
import SectionBasic from '@/components/SectionBasic.vue'
import FormGenerator from '@/components/FormGenerator.vue'
import BlockWarning from '@/components/BlockWarning.vue'
import { getFullDate } from '@/helpers/reformatDate.js'
import BlockBreadCrumbs from '@/components/BlockBreadCrumbs.vue'
import { FormInputType } from '@/contracts/FormInputType'
import BlockForms from '@/components/BlockForms.vue'
import Link from '@/components/Link.vue'

export default defineComponent({
  name: 'SectionCheckBlanks',
  components: {
    BlockForms,
    Loader,
    SectionBasic,
    FormGenerator,
    BlockWarning,
    BlockBreadCrumbs,
    Link,
  },
  mixins: [sectionCoreProps],
  setup() {
    const { $api } = useContext()
    const loading = ref(false)
    // Список возможных состояний блока
    const STATUS_LIST = ref({
      new: 'new',
      success: 'success',
      'не найден': 'not-found',
      найден: 'found',
      утрачен: 'lost',
    })
    // Текущее состояние блока
    const status = ref(STATUS_LIST.value.new)
    const isFormSend = ref(false)
    const warningDataNotFound = ref({
      title: 'Мы не нашли бланк в своей базе',
      textPreview: `Бланк с указанными реквизитами в базах ПАО СК «Росгосстрах» не найден / неверно введен номер бланка<br><br>Обращаем внимание, что проверка по номеру полиса на сайте не является 100% гарантией подлинности предлагаемого вам полиса. Приобретайте полисы в офисах продаж компании «Росгосстрах» или у авторизированных партнёров.`,
    })
    const warningData = ref<any>('')
    const sectionLink = ref({
      value: 'Проверить другие данные',
      link: '#',
      arrowType: 'arrow-left',
    })
    const forms = ref([
      {
        id: 'bsoSeries',
        type: FormInputType.Tel,
        label: 'Введите серию бланка',
        formKey: 'Введите серию бланка',
        placeholder: 'Введите серию бланка',
        field: 'InputText',
        rules: ['required', 'bsoSeries', 'minLength', 'maxLength'],
        minLength: 1,
        maxLength: 50,
        tooltip: 'true',
      },
      {
        id: 'bsoNumber',
        type: FormInputType.Tel,
        label: 'Введите номер бланка',
        formKey: 'Введите номер бланка',
        placeholder: 'Введите номер бланка',
        field: 'InputText',
        rules: ['required', 'bsoNumber', 'minLength', 'maxLength'],
        minLength: 1,
        maxLength: 50,
        tooltip: 'true',
      },
    ])
    const formData = ref({
      btnLabel: 'Проверить бланк',
      forms,
    })
    const formDataResult = ref({
      formType: 'bso',
      formTitle:
        'Сообщите, если вам предлагают купить бланк с таким номером или вы уже его купили',
    })

    const successText = 'Ваше сообщение отправлено, спасибо.'

    const buttons = ref<any>({
      urlLink: '/',
      toHomeText: 'Перейти на главную',
      toStartText: 'Проверить другие данные',
    })
    const resetSection = () => {
      status.value = STATUS_LIST.value.new
      isFormSend.value = false
    }
    const onSuccess = () => {
      status.value = STATUS_LIST.value.success
    }
    // Ищем бсо, статус которого один из STATUS_LIST и возвращаем самый актуальный по дате
    const findActualBso = (bsoArr) => {
      if (!bsoArr?.length) {
        return null
      }
      const withRightStatus = bsoArr.filter((v) =>
        Object.keys(STATUS_LIST.value).includes(v.status)
      )
      if (!withRightStatus?.length) {
        return null
      }
      const bso = withRightStatus.reduce((acc, val) => {
        const accDate = new Date(acc.statusDate).getTime()
        const valDate = new Date(val.statusDate).getTime()
        return accDate > valDate ? acc : val
      })
      return bso
    }
    const reformatWarningData = (bso: any) => {
      return bso.statusText
        .replace(bso.statusDate, getFullDate(bso.statusDate))
        .replace('. ', '<br><br>')
    }
    const reformatMessageText = (
      bso: any,
      bsoSeries: string,
      bsoNumber: string
    ) => {
      const statusText = reformatWarningData(bso)

      const textMessage = `<b>Бланк:</b> Серия: ${bsoSeries} Номер: ${bsoNumber} <br> <b>Статус бланка:</b> ${statusText} <br> ${
        bso.statusDate
          ? `<b>Дата статуса:</b> ${getFullDate(bso.statusDate)}`
          : ''
      }`
      return textMessage
    }
    const reformatNotFoundText = (
      bso: any,
      bsoSeries: string,
      bsoNumber: string
    ) => {
      const statusText = reformatWarningData(bso)
      const textMessage = `Бланк с указанными реквизитами <br> <b>Серия:</b> ${bsoSeries} <br> <b>Номер:</b> ${bsoNumber} <br> в базах ПАО СК «Росгосстрах» не найден / неверно введен номер бланка<br> ${
        statusText ? `<b>Статус бланка:</b> ${statusText}` : ''
      } <br> ${
        bso.statusDate
          ? `<b>Дата статуса:</b> ${getFullDate(bso.statusDate)}`
          : ''
      } <br> Обращаем внимание, что проверка по номеру полиса на сайте не является 100% гарантией подлинности предлагаемого вам полиса. Приобретайте полисы в офисах продаж компании «Росгосстрах» или у авторизированных партнёров.`
      return textMessage
    }
    const onSubmit = async (evt: any) => {
      if (status.value === STATUS_LIST.value.new) {
        loading.value = true
        const { bsoSeries, bsoNumber } = evt

        const response = await $api.requests.checkBso({
          series: bsoSeries,
          number: bsoNumber,
        })
        const bso = findActualBso(response?.data?.data?.businessData?.bso)
        if (bso) {
          status.value = STATUS_LIST.value[bso.status]
          warningData.value = bso.statusText
            ? reformatMessageText(bso, bsoSeries, bsoNumber)
            : ''
          warningDataNotFound.value.textPreview = reformatNotFoundText(
            bso,
            bsoSeries,
            bsoNumber
          )
        } else {
          warningDataNotFound.value.textPreview = `Бланк с указанными реквизитами в базах ПАО СК «Росгосстрах» не найден / неверно введен номер бланка<br><br>Обращаем внимание, что проверка по номеру полиса на сайте не является 100% гарантией подлинности предлагаемого вам полиса. Приобретайте полисы в офисах продаж компании «Росгосстрах» или у авторизированных партнёров.`
          status.value = STATUS_LIST.value['не найден']
        }
        loading.value = false
      }
    }

    return {
      STATUS_LIST,
      status,
      isFormSend,
      resetSection,
      onSubmit,
      forms,
      loading,
      formData,
      warningData,
      sectionLink,
      warningDataNotFound,
      successText,
      buttons,
      formDataResult,
      onSuccess,
    }
  },
})
